import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ra-bill-form',
  templateUrl: './ra-bill-form.component.html',
  styleUrls: ['./ra-bill-form.component.css']
})
export class RaBillFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/technical/billing/ra-bill/ra-bill-form/ra-bill-form.component.ts